import { c as _c } from "react/compiler-runtime";
import React, { FC } from "react";
import { ComponentBlocksParagraph, Maybe } from "@lib/generated/graphql";
const TextItems: FC<{
  items?: Maybe<Array<Maybe<ComponentBlocksParagraph>>>;
}> = t0 => {
  const $ = _c(4);
  const {
    items
  } = t0;
  if (!items) {
    return null;
  }
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="grid grid-cols-1 s:grid-cols-2 gap gap-y-m s:gap-y-3m pt-2m">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default TextItems;
function _temp(item, index) {
  return <li key={index}><span className="text-d1 font-light mb-2xs block">{item?.title}</span><span className="text-body-1">{item?.body}</span></li>;
}